export const toStringNumber = (number, maxDigits = 2, roundDecimalPart = false, leadingZeroes = false) => {
    const [mainPart, decimalPart] = number.toString().split(/[\\.,]/);
    const addition = roundDecimalPart && decimalPart ? Math.round(parseFloat(`0.${decimalPart}`)) : 0;
    const mainPartCalculated = parseInt(mainPart, 10) + addition;
    let generatedString = '' + mainPartCalculated;
    if (leadingZeroes) {
        const leadingZeroesCount = maxDigits - `${mainPartCalculated}`.length;
        for (let i = 0; i < leadingZeroesCount; i++) {
            generatedString = '0' + generatedString;
        }
    }
    return generatedString;
};
//# sourceMappingURL=to-string-number.js.map